import api from "./apiService";

export function getAllPaymentHistory(payload) {
  const params = new URLSearchParams();
  params.append("start_date", payload.startDate);
  params.append("end_date", payload.endDate);
  params.append("page", payload.page);
  params.append("limit", payload.limit);
  return api
    .get(`/admin/payments/get-all-payment-history`, { params })
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getAllExportPayment(payload) {
  const params = new URLSearchParams();
  params.append("start_date", payload.startDate);
  params.append("end_date", payload.endDate);
  return api
    .get(`/admin/payments/get-all-payment-history-export`, { params })
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getPaymentInvoice(id) {
  return api
    .get(`payments/get-payment-history/${id}`)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      throw err;
    });
}

export function getSettlement(page, limit) {
  return api
    .get(`/admin/payments/get-host-settlements/?page=${page}&limit=${limit}`)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      throw err;
    });
}

export function getSettlementSummary() {
  return api
    .get(`/admin/payments/get-host-settlement-summary`)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      throw err;
    });
}

export function markSettlementPaid(id) {
  return api
    .patch(`/admin/payments/mark-settlement-as-paid/${id}`)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      throw err;
    });
}



//////////////////
// WEBPACK FOOTER
// ./services/invoice.js
// module id = null
// module chunks = 